const layoutSafelist = () => {
  const breakpoints = ['', 'sm:', 'md:', 'lg:', 'xl:', 'full:']
  const sizes = ['full', '1/2', '1/3', '1/4']

  return breakpoints.reduce((allClasses, bp) => {
    const classes = sizes.map((s) => `${bp}w-${s}`)
    return [...allClasses, ...classes]
  }, [])
}

const colors = {
  black: '#111111',
  'off-black': '#1A1A1A',
  'grey-dark': '#2B2B2B',
  grey: {
    DEFAULT: '#D5D8DA',
    100: '#F9F9F9',
    200: '#f7f7fa',
    300: '#f2f2f5',
    400: '#EBEBEB',
    500: '#afafaf',
    600: '#898989',
    700: '#555555',
    800: '#2B2B2B',
  },
  'grey-light': '#f2f2f5',
  'grey-lighter': '#f7f7fa',
  'mid-grey': '#afafaf',
  white: '#FFFFFF',
  blue: '#3449B8',
  'blue-light': '#1799E1',
  purple: '#5C0F99',
  orange: '#FF4D00',
  green: '#41B675',
  red: '#ff3128',
  papaya: '#FF9E1B',
  yellow: '#EBF401',
  'legacy-blue': '#00669f',
  'legacy-blue-dark': '#004369',
  'dr3-khaki': '#373425',
  'ln4-yellow': '#BDDC00',
  'dr3-purple': '#6D467D',
  'momentum-purple': '#5500F6',
  whatsapp: '#34d366',
}

const colorSafelist = () => {
  return Object.keys(colors).map((color) => `bg-${color}`)
}

const safelist = [...layoutSafelist(), ...colorSafelist()]

export const screenSizes = {
  xxs: 375,
  xs: 400,
  sm: 650,
  md: 800,
  lg: 1000,
  xl: 1150,
  xxl: 1500,
  full: 1920
}

export default {
  mode: 'jit',
  screenSizes,
  theme: {
    extend: {
      colors,
      fontFamily: {
        sans: ['Lausanne', 'system-ui'],
        mono: ['Fragment Mono', 'system-ui'],
      },
      fontSize: {
        huge: '120px',
        '6xl': '64px',
        '4xl': '48px',
        '3xl': '40px',
        '2xl': '32px',
        xl: '26px',
        lg: '24px',
        md: '22px',
        base: '18px',
        sm: '15px',
        xs: '14px',
        xxs: '12px',
        tiny: '10px'
      },
      fontWeight: {
        thin: 200,
        light: 200,
        normal: 200,
        medium: 300,
        semibold: 600,
        bold: 600,
        extrabold: 600,
      },
      letterSpacing: {
        tighter: '-.02em',
        tight: '-.01em',
        normal: '0',
        wide: '.02em',
        wider: '.03em',
      },
      lineHeight: {
        tighter: '1.1',
        tight: '1.2',
        normal: '1.5',
      },
      screens: {
        xxs: `${screenSizes.xxs}px`,
        xxsMax: { max: `${screenSizes.xxs - 1}px` },
        xs: `${screenSizes.xs}px`,
        xsMax: { max: `${screenSizes.xs - 1}px` },
        sm: `${screenSizes.sm}px`,
        smMax: { max: `${screenSizes.sm - 1}px` },
        md: `${screenSizes.md}px`,
        mdMax: { max: `${screenSizes.md - 1}px` },
        lg: `${screenSizes.lg}px`,
        lgMax: { max: `${screenSizes.lg - 1}px` },
        xl: `${screenSizes.xl}px`,
        xlMax: { max: `${screenSizes.xl - 1}px` },
        xxl: `${screenSizes.xxl}px`,
        xxlMax: { max: `${screenSizes.xxl - 1}px` },
        full: `${screenSizes.full}px`,
        fullMax: { max: `${screenSizes.full - 1}px` },
        short: { raw: '(max-height: 700px)' },
        xShort: { raw: `(max-height: ${screenSizes.sm}px)` },
        xxShort: { raw: '(max-height: 570px)' },
      },
      spacing: {
        0: '0', // 0
        xxxs: '0.5rem', // 8
        xxs: '0.75rem', // 12
        xs: '1rem', // 16
        sm: '1.5rem', // 24
        md: '3rem', // 48
        lg: '5rem', // 80
        xl: '7.5rem', // 120
        xxl: '8.75rem', // 140
      },
      zIndex: { '-1': '-1', 11: 11 },
      opacity: {
        2: 0.2,
      },
      backgroundImage: {
        gradient: 'var(--gradient)',
        'gradient-green': 'var(--gradient-green)',
        'gradient-light': 'var(--gradient-light)',
      },
    },
  },
  safelist: [
    ...safelist,
    'w-xxxs',
    'w-xxs',
    'w-xs',
    'w-sm',
    'w-md',
    'w-lg',
    'w-xl',
    'w-xxl',
    'normal-case',
  ],
}
